import {FlagProps, NotificationItemData} from 'platform/components';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';
import {warehouseRoutes} from '@dms/routes';

import {EXTRACT_DELIVERY_NOTE_DOCUMENT} from '@prompt-bridge/shared/validations';

import {composePath, noop, parseDate} from 'shared/web';

import {PromptBridgeNotificationParams} from '../types/PromptBridgeNotificationParams';
import {isDeliveryNoteInput} from './isDeliveryNoteInput';

export const buildPromptBridgeNotification = (
  params: PromptBridgeNotificationParams
): NotificationItemData =>
  match(params.message.useCaseType)
    .with(EXTRACT_DELIVERY_NOTE_DOCUMENT, () => {
      const flags = match(params.notification.payload.status)
        .returnType<Omit<FlagProps, 'size'>[] | undefined>()
        .with('SUCCESS', () => [
          {label: i18n.t('general.notifications.labels.actionNeeded'), colorScheme: 'yellow'},
        ])
        .with('FAILED', () => [
          {label: i18n.t('general.notifications.labels.failed'), colorScheme: 'red'},
        ])
        .otherwise(() => undefined);

      const title = match(params.notification.payload.status)
        .with('SUCCESS', () => i18n.t('general.notifications.labels.promptBridgeDocumentSuccess'))
        .with('FAILED', () => i18n.t('general.notifications.labels.promptBridgeDocumentError'))
        .otherwise(() => '');

      const input = isDeliveryNoteInput(params.message.input) ? params.message.input : null;

      const resource = input?.fileName ?? '';

      const url = composePath(warehouseRoutes.deliveryNoteDocumentPreview, {
        params: {id: params.notification.payload.messageId},
        isSearchParamsPreserved: false,
      });

      return {
        id: params.notification.id,
        isRead: params.notification.isRead,
        created: parseDate(params.notification.createdAt),
        flags,
        title,
        resource,
        onClick: () => {
          window.open(url, '_blank');
        },
      };
    })
    .otherwise(() => ({
      id: params.notification.id,
      isRead: params.notification.isRead,
      created: parseDate(params.notification.createdAt),
      title: i18n.t('general.notifications.labels.promptBridgeFallbackTitle'),
      resource: '',
      onClick: noop,
    }));
